module.exports = __webpack_public_path__ + "img/free_play.42283cf5.svg";